import React, {useEffect, useState} from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {useSelector} from "react-redux";
import ListConfig, {FilterConfig, SortConfig} from "../../components/list/ListConfig";
import NoticeListFilterConfig from "../../features/notices/list/NoticeListFilterConfig";
import NoticeListSortConfig from "../../features/notices/list/NoticeListSortConfig";
import NoticeListDataManager from "../../features/notices/list/NoticeListDataManager";
import StandardListView, {StandardListViewItems} from "../../components/list/StandardListView";
import {store} from '../../redux/store'
import {filterByPhraseChanged, phraseChanged, offsetChanged} from "../../features/notices/list/noticeListSlice";
import {useDebouncedCallback} from "use-debounce";
import DateTimeFormatter from "../../utils/formatters/DateTimeFormatter";
import {useNavigate, useMatch, Outlet} from "react-router-dom";
import Routes from "../../features/router/Routes";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import NoticeService from "../../features/notices/NoticeService";
import FloatingAlert from "../../components/notifications/FloatingAlert";
import ErrorUtils from "../../utils/error/ErrorUtils";

function NoticeListItem(props) {
    const navigate = useNavigate()

    return (
        <>
            <ListItem secondaryAction={
                <>
                    <IconButton onClick={() => {
                        navigate('.' + Routes.Notices.Edit.replace(':noticeId', props.data.id))
                    }}>
                        <EditIcon/>
                    </IconButton>

                    <IconButton onClick={() => props.onDeleteClick(props.data)}>
                        <DeleteIcon/>
                    </IconButton>
                </>
            }>
                <ListItemText
                    primary={ props.data.title }
                    secondary={ (
                        <>
                            Data utworzenia: { DateTimeFormatter.format(props.data.createdAt) }
                            <br/>
                            Data publikacji: { DateTimeFormatter.format(props.data.publicationFromDate) } - { DateTimeFormatter.format(props.data.publicationThruDate) }
                            <br/>
                            Data przypięcia: { DateTimeFormatter.format(props.data.pinFromDate) } - { DateTimeFormatter.format(props.data.pinThruDate) }
                        </>
                    )}>
                </ListItemText>
            </ListItem>

            <Divider/>
        </>
    )
}

export function NoticesPage() {
    const navigate = useNavigate()
    const data = useSelector((state) => state.noticeList.data)
    const [currentItem, setCurrentItem] = useState(null)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const loadData = useDebouncedCallback(() => {
        NoticeListDataManager.load()
    }, 1000)

    useEffect(() => {
        setCurrentItem(null)
        store.dispatch(offsetChanged(0))
        NoticeListDataManager.load()
    }, [])

    if (!useMatch(Routes.Notices.Index)) {
        return <Outlet/>
    }

    return (
        <>
            <StandardListView
                title={"Ogłoszenia"}
                initialize={() => {
                    return {
                        showSearchInput: store.getState().noticeList.requestParams.filterByPhrase,
                        searchPhrase: store.getState().noticeList.requestParams.phrase
                    }
                }}
                onSearchButtonClick={(showSearchInput) => {
                    store.dispatch(filterByPhraseChanged(showSearchInput))
                    loadData()
                }}
                onSearchPhraseChange={(e) => {
                    store.dispatch(phraseChanged(e.target.value))
                    loadData()
                }}
                onAddButtonClick={() => {
                    NoticeService.createNotice({
                        title: 'Nowy wpis'
                    }).then((r) => {
                        console.info("The notice #" + r.data.id + " has been created.")
                        store.dispatch(offsetChanged(0))
                        NoticeListDataManager.load()
                        navigate('.' + Routes.Notices.Edit.replace(':noticeId', r.data.id))
                    }).catch(err => {
                        console.error(err)
                        setShowError(true)
                        setErrorMessage(ErrorUtils.getMessage(err))
                    })
                }}
                loadData={() => loadData()}
                data={data}>
                <StandardListViewItems>
                    {
                        data.items.map((i) => (
                            <NoticeListItem key={i.id} data={i} onDeleteClick={(i) => {
                                setCurrentItem(i)
                                setOpenConfirmDialog(true)
                            }}/>
                        ))
                    }
                </StandardListViewItems>

                <ListConfig>
                    <FilterConfig>
                        <NoticeListFilterConfig/>
                    </FilterConfig>

                    <SortConfig>
                        <NoticeListSortConfig/>
                    </SortConfig>
                </ListConfig>
            </StandardListView>

            <Dialog open={openConfirmDialog}>
                <DialogTitle>Potwierdź usunięcie zasobu</DialogTitle>
                <DialogContent dividers>
                    Czy na pewno chcesz usunąc wpis {currentItem?.title}?
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => {
                        setOpenConfirmDialog(false)
                    }}>
                        Anuluj
                    </Button>

                    <Button onClick={() => {
                        setOpenConfirmDialog(false)

                        NoticeService.deleteNotice(currentItem.id)
                            .then(() => {
                                console.info("The notice #" + currentItem.id + " has been deleted.")
                                store.dispatch(offsetChanged(0))
                                NoticeListDataManager.load()
                            })
                            .catch(err => {
                                console.error(err)
                                setShowError(true)
                                setErrorMessage(ErrorUtils.getMessage(err))
                            })
                    }}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <FloatingAlert open={showError}
                           severity="error"
                           message={errorMessage}
                           viewHasActionButton={true}
                           onClose={() => setShowError(false)}/>
        </>
    )
}